module.exports = __webpack_public_path__ + "img/05.48634147.png";